import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useApiGet } from '../../../utils/httpClientTs';
import { getMyPermissions } from '../../../endpoints/usersTs';
import { hasUserApplicationPermission } from '../../../utils/permissions';

/** Requires any foundation:* permission so recommenders can reach Applicants without view. */
export const CanViewFoundationAwards: React.FC = () => {
  const { data: permissions, isLoading } = useApiGet<string[]>(
    ['my-permissions-foundation'],
    () => getMyPermissions({ international: '1' }),
    { enabled: true, retry: 1 }
  );

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  const canAccess =
    hasUserApplicationPermission(permissions, 'foundation:view') ||
    hasUserApplicationPermission(permissions, 'foundation:recommend') ||
    hasUserApplicationPermission(permissions, 'foundation:review') ||
    hasUserApplicationPermission(permissions, 'foundation:manage');
  return canAccess ? <Outlet /> : <Navigate to="/foundation" replace />;
};

export default CanViewFoundationAwards;
